import React, { useState } from "react";
import { ButtonProps, CommandBarButton, depascalize } from "sprint-common-web";

import { useOnPremAssetDetails } from "../common/hooks/useOnPremAssetDetails";
import { OnPremAssetStatus } from "../OnPremAssetStatus";
import { DeprecateStatusDialog } from "./ConfirmDialogs/DeprecateStatusDialog";

export type AssetStatusButtonProps = Pick<ButtonProps, "disabled">;

interface StatusButtonConfig {
    status: OnPremAssetStatus;
    title: "Deprecate";
    icon: string;
}

export const OnPremAssetStatusButton: React.FunctionComponent<AssetStatusButtonProps | undefined> = (
    props: AssetStatusButtonProps
) => {
    const { data: assetDetails } = useOnPremAssetDetails();

    const [pickedStatus, setPickedStatus] = useState<OnPremAssetStatus>();

    const statusButtons: StatusButtonConfig[] = [
        {
            status: OnPremAssetStatus.Deprecated,
            title: "Deprecate",
            icon: "PageRemove"
        }
    ];

    const getStatusButtonDetails = (status?: OnPremAssetStatus) => {
        return statusButtons.find((details: StatusButtonConfig) => details.status === status);
    };

    const getCurrentIcon = () => {
        return getStatusButtonDetails(assetDetails?.status)?.icon;
    };

    const pickStatusAndOpenConfirmDialog = (status: OnPremAssetStatus) => {
        setPickedStatus(status);
    };

    const clearStatus = () => {
        setPickedStatus(undefined);
    };

    const isOpened = !!pickedStatus;

    if (!assetDetails) {
        return null;
    }

    return (
        <>
            <CommandBarButton
                text={`Status: ${depascalize(OnPremAssetStatus[assetDetails.status]) || "..."}`}
                icon={getCurrentIcon()}
                testId="asset-status-dropdown"
                disabled={props?.disabled || (assetDetails && assetDetails.status === OnPremAssetStatus.Deprecated)}
                menuItems={statusButtons.map((button: StatusButtonConfig) => ({
                    text: button.title,
                    icon: button.icon,
                    disabled: assetDetails?.status ? assetDetails.status === OnPremAssetStatus.Deprecated : false,
                    onClick: () => pickStatusAndOpenConfirmDialog(button.status)
                }))}
            />
            <DeprecateStatusDialog isOpened={isOpened} onDismiss={clearStatus} />
        </>
    );
};
